module.exports = __webpack_public_path__ + "media/images/official/plan_ticket_icon2-a181384519e6db065f140d478b174bf8.svg";